const authHeader = () => {
  let user = JSON.parse(localStorage.getItem('user'))
  if (user && user.token) {
    return { 
      Authorization: 'Bearer ' + user.token,
      'X-Requested-With': 'XMLHttpRequest'
    }
  } else {
    return {};
  }
}

export default authHeader
